export default [
    {
        path: '/(uk/|ru/)?/promotions/index',
        component: () => import('../views/promotions/Index'),
        name: 'PromotionsList',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Акции'
        },
    }, {
        path: '/(uk/|ru/)?/promotions/commission-free',
        component: () => import('../views/promotions/commissionFree/index'),
        name: 'CommissionFree',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Настройка акционных периодов'
        },
    }, {
        path: '/(uk/|ru/)?/promotions/commission-free/edit',
        component: () => import('../views/promotions/commissionFree/edit'),
        name: 'CommissionFreeEdit',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title:'Настройка акционных периодов'
        },
    }, {
        path: '',
        component: () => import('../views/promotions/Edit'),
        altNavSubMenuActive:'/promotions/index',
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
        },
        children: [
            {
                path: '/(uk/|ru/)?/promotions/edit',
                name: 'PromotionEditMain',
                component: () => import('../views/promotions/modules/Main'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/work-rules',
                name: 'PromotionWorkRules',
                component: () => import('../views/promotions/modules/WorkRules'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/raffle-coupon',
                name: 'PromotionRaffleCoupon',
                component: () => import('../views/promotions/modules/RaffleCoupon'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/raffle-ddriver',
                name: 'PromotionRaffleDriver',
                component: () => import('../views/promotions/modules/RaffleDriver'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/reports/transactions',
                name: 'PromotionCompensationTransaction',
                component: () => import('../views/promotions/modules/Transactions'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/reports/drivers',
                name: 'PromotionCompensationDrivers',
                component: () => import('../views/promotions/modules/PromotionCompensationDrivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/pay-history',
                name: 'PromotionPayHistory',
                component: () => import('../views/promotions/modules/PromotionPayHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/participate-history',
                name: 'PromotionParticipateHistory',
                component: () => import('../views/promotions/modules/PromotionParticipateHistory'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers/import',
                name: 'PromotionAddDrivers',
                component: () => import('../views/promotions/modules/PromotionAddDrivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            }, {
                path: '/(uk/|ru/)?/promotions/drivers',
                name: 'PromotionDriver',
                component: () => import('../views/promotions/modules/Driver'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-discount',
                    title:'Акции'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/push-notification/list',
        name: 'PushList',
        component: () => import('../views/push/List.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Рассылки уведомлений'
        },
    }, {
        path: '/(uk/|ru/)?/push-notification/create',
        name: 'PushCreate',
        component: () => import('../views/push/Create.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Создать рассылку',
            altNavSubMenuActive:'/push-notification/list',
        },
    }, {
        path: '/(uk/|ru/)?/promocodes/index',
        name: 'Promocodes',
        component: () => import('../views/promocodes/Promo'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '/(uk/|ru/)?/polls/index',
        name: 'polls',
        component: () => import('../views/polls/index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    }, {
        path: '/(uk/|ru/)?/polls/view',
        name: 'pollsview',
        component: () => import('../views/polls/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    }, {
        path: '/(uk/|ru/)?/polls/edit',
        name: 'PollEdit',
        component: () => import('../views/polls/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Опросы'
        }
    }, {
        path: '/(uk/|ru/)?/promocodes/detail',
        name: 'PromocodeDetaild',
        component: () => import('../views/promocodes/Detail'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '/(uk/|ru/)?/promocodes/edit',
        name: 'PromocodesEdit',
        component: () => import('../views/promocodes/Edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Промокоды'
        }
    }, {
        path: '',
        component: () => import('../views/refferall/idnex.vue'),
        meta: {
            requiresAuth: true,
            altNavSubMenuActive:'/promotions/referrals-list',
        },
        children: [{
            path: '/(uk/|ru/)?/promotions/referrals-list',
            name: 'refferallActive',
            component: () => import('../views/refferall/tables/active.vue'),
            meta: {
                requiresAuth: true,
                title: 'Реферельная программа',
                activeSideIcon:'#icon-discount',
            },
        }, {
            path: '/(uk/|ru/)?/promotions/referrals-list/archive',
            name: 'refferallArchive',
            component: () => import('../views/refferall/tables/archive.vue'),
            meta: {
                requiresAuth: true,
                title: 'Реферельная программа: архив',
                activeSideIcon:'#icon-discount',
            },
        }]
    },
]
